/** The reports screen: today's takings, the action list and the GST summary. */
export default {
  'reports.subtitle': "Today's takings, the action list, and the GST summary",
  'reports.view': 'Report view',
  'reports.dashboard': 'Dashboard',
  'reports.gst': 'GST summary',
  'reports.dashboardFailed': 'Could not load the dashboard',
  'reports.gstFailed': 'Could not load the GST summary',
  'reports.salesToday': 'Sales today',
  'reports.avgBill': 'Average bill',
  'reports.bills': { one: '{count} bill', other: '{count} bills' },
  'reports.noSales': 'no sales yet',
  'reports.discounts': 'Discounts given',
  'reports.tax': 'GST collected {amount}',
  'reports.noTax': '{bills} today went out with No Tax: {amount} of tax taken off. Each one is in the audit trail.',
  'reports.last7': 'Last 7 days',
  'reports.last7Title': 'Sales for the last 7 days',
  'reports.last7Empty': 'No sales in the last 7 days.',
  'reports.byHour': 'Today by hour',
  'reports.byHourTitle': 'Sales today by hour',
  'reports.actions': 'Action required',
  'reports.busiest': 'Busiest hour today: {hour} with {amount} across {bills} (as of {time}).',
  'reports.noMargin': 'Margin and profit figures are only shown to a role that holds the `report.profit` permission.',
  'reports.lowStock': 'Below minimum stock',
  'reports.negativeStock': 'Negative stock',
  'reports.expiredBatches': 'Expired batches',
  'reports.pendingPOs': 'Purchase orders to approve',
  'reports.cashDifferences': 'Shifts with a cash difference',
  'reports.pendingSync': 'Sync operations queued',
  'reports.failedSync': 'Sync operations failed',
  'reports.pendingEvents': 'Events awaiting delivery',
  'reports.failedImports': 'Failed CSV imports',
  'reports.chartEmpty': 'Nothing to chart yet.',
  'reports.bySlab': 'Tax collected this month, by slab',
  'reports.gstr1': 'These figures are the GSTR-1 input. Taxable value excludes the tax itself.',
  'reports.slab': 'Slab',
  'reports.taxable': 'Taxable value',
  'reports.cess': 'Cess',
  'reports.byHsn': 'By HSN code',
  'reports.taxCol': 'Tax',
} as const;
